import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../../model/widget.model';
@Component({
    selector: 'app-crm-board-widget.settings',
    templateUrl: './crm-board-widget.settings.component.html',
    styleUrl: './crm-board-widget.settings.component.scss'
})
export class AppBoardWidgetSettingsComponent {
    @Input() widget: WidgetModel;
}